var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPixellab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.7 141.7",
    style: {
      enableBackground: "new 0 0 156.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo--pixellab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,84.3l-2.9-4.2l-2.9,4.2H116.4L116.4,84.3z M98.8,84.3l-6.7,9.6h31l-5.5-7.8h-10.4l5.2-7.4l-4.8-6.8 L98.8,84.3L98.8,84.3z M93.9,74.8l-20.2,28.7h56.1l-5.5-7.8H88.8l17.8-25.3l-4.8-6.8L93.9,74.8L93.9,74.8z M88.9,65.2L55.3,113h81.3 l-5.5-7.8H70.3l30.4-43.2l-4.8-6.8L88.9,65.2L88.9,65.2z M133.8,114.8H51.9l43.5-61.8V39.3l-58.6,83.3h106.4l-5.5-7.8H133.8 L133.8,114.8z M138.7,124.3H33.5l61.9-88V22.7l-77,109.5H150l-5.5-7.8H138.7L138.7,124.3z M154.4,138.4l-3.1-4.5H15.1L95.4,19.7V6.1 L0,141.7h156.7L154.4,138.4L154.4,138.4z M70.7,38.3L95.4,3.1V0H88L61.3,38.3v13.3L70.7,38.3L70.7,38.3z M72.4,19.1L85.9,0h-9.6 l-15,21.3v13.6L72.4,19.1L72.4,19.1z M74.2,0H61.3v18.3L74.2,0L74.2,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPixellab);
export default __webpack_public_path__ + "static/media/logo--pixellab.ede58884.svg";
export { ForwardRef as ReactComponent };